var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-card qr-box"},[_c('div',{staticClass:"left"},[_c('c-image',{attrs:{"src":require('@/assets/img/performance/ticket.png')}}),_c('span',[_vm._v("掌上购票")])],1),_c('div',{staticClass:"right"},[_c('c-image',{attrs:{"src":require('@/assets/img/performance/wechat.jpg')}}),_c('span',[_vm._v("微信扫一扫手机购票")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }